import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import store from "./store";
import { REACT_APP_CHAIN_ID} from "../Config/Config"


const ChainId = REACT_APP_CHAIN_ID;

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

export const disconnectRequest = () => {
  return {
    type: "DISCONNECT",
  };
};

export const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

export const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};


const getProviderOptions = () => {
  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        //infuraId: process.env.REACT_APP_INFURA_ID
        rpc: {
          11155111: "https://endpoints.omniatech.io/v1/eth/sepolia/public",
          11112: "https://www.rpc.openzkbeta.click/",
          4681: "https://openzk-testnet.rpc.caldera.xyz/http"
        }
      }
    }
  }
  return providerOptions;
}

export const connectWallet = (walletname) => {
  return async (dispatch) => {
    dispatch(connectRequest());
    try {
      const web3Modal = new Web3Modal({
        cacheProvider: true,
        providerOptions: getProviderOptions(), // required
      });

      var provider = "";
      if (walletname === "coinbasewallet") {
        //eslint-disable-next-line
        provider = await web3Modal.connectTo("coinbasewallet");
      } else if (walletname === "walletconnect") {
        //eslint-disable-next-line
        provider = await web3Modal.connectTo("walletconnect");
      } else if (walletname === "fortmatic") {
        //eslint-disable-next-line
        const fm = new Fortmatic(testAPIKey, customNodeOptions);
        provider = new Web3(fm.getProvider());
        // provider = await web3Modal.connectTo("fortmatic");
      } else if (walletname === "metamask") {
        const web3Modal = new Web3Modal({
          cacheProvider: true,
          providerOptions: getProviderOptions().walletconnect, // required
        });
        //eslint-disable-next-line
        provider = await web3Modal.connect();
      } else {
        const web3Modal = new Web3Modal({
          cacheProvider: true,
          providerOptions: getProviderOptions().walletconnect, // required
        });
        //eslint-disable-next-line
        provider = await web3Modal.connect();
      }


      await subscribeProvider(provider);
      const web3 = new Web3(provider);

      web3.eth.extend({
        methods: [
          {
            name: "chainId",
            call: "eth_chainId",
            outputFormatter: web3.utils.hexToNumber,
          },
        ],
      });


      const accounts = await web3.eth.getAccounts();
      const address = accounts[0];

      const totalBalance= 0
      const owneradd =""
      console.log("owneradd==>",owneradd)
      console.log("address==>",address)
      console.log("totalBalance==>",totalBalance)



    } catch (e) {
      dispatch(connectFailed(e));
    }
  }
}

const subscribeProvider = async (provider) => {
  if (!provider.on) {
    return;
  }

  provider.on("connect", async (id) => {
    console.log(id);
  });

  provider.on("networkChanged", async (networkId) => {
    if (networkId !== ChainId) {
      console.log(networkId);
      store.dispatch(connectFailed("Please switch to Binance Testnet"));
    } else {
      store.dispatch(connectWallet());
    }
  });
}

export async function addNetwork(id) {
  let networkData;
  switch (id) {
  //bsctestnet
  case 97:
    networkData = [
      {
        chainId: "0x61",
        chainName: "BSCTESTNET",
        rpcUrls: ["https://bsc-testnet-rpc.publicnode.com"],
        nativeCurrency: {
          name: "BINANCE COIN",
          symbol: "tBNB",
          decimals: 18,
        },
        blockExplorerUrls: ["https://testnet.bscscan.com/"],
      },
    ];

    break;
    //bscmainet
  case 56:
    networkData = [
      {
        chainId: "0x38",
        chainName: "BSCMAINET",
        rpcUrls: ["https://bsc-dataseed1.binance.org"],
        nativeCurrency: {
          name: "BINANCE COIN",
          symbol: "BNB",
          decimals: 18,
        },
        blockExplorerUrls: ["https://testnet.bscscan.com/"],
      },
    ];
    break;
  case 11155111:
    networkData=JSON.stringify(networkData)
    networkData = [
      {
        chainId: "0xaa36a7"
      }
    ]
    break; 
  case 11112:
    networkData = [
      {
        chainId: "0x2b68",
        chainName: "OpenZK Testnet",
        rpcUrls: ["https://www.rpc.openzkbeta.click/"],
        nativeCurrency: {
          name: "OpenZK Testnet",
          symbol: "OZK",
          decimals: 18,
        },
        blockExplorerUrls: ["https://www.testnet.openzkbeta.click/"],
      },
    ]
    break;
  case 4681:
    networkData = [
      {
        chainId: "0x1249",
        chainName: "openzk-testnet",
        rpcUrls: ["https://openzk-testnet.rpc.caldera.xyz/http"],
        nativeCurrency: {
          name: "openzk-testnet",
          symbol: "OZK", 
          decimals: 18,
        },                   
        blockExplorerUrls: ["https://openzk-testnet.explorer.caldera.xyz"],
      },
    ]
    break;
  default:
    break;
  }
  if (id != REACT_APP_CHAIN_ID) {
    connectWallet()
    return window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: networkData,
    });
    
  } else {
    connectWallet()
    return window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: networkData,
    });
  }
}

(() => {
  if (window.ethereum) {
    window.ethereum.on("networkChanged", function () {
      store.dispatch(connectWallet());
    });
  }
})();



